/* eslint-disable */
/**
 * 手机端通用组件套件
 * 在 main.js 里 Vue.use(MobileKit) 之后，所有页面可直接使用：
 *   <m-page> <m-table> <m-search> <m-sheet> <m-fab> <m-pager> <m-toolbar>
 */
import MPage from './m-page.vue';
import MTable from './m-table.vue';
import MSearch from './m-search.vue';
import MSheet from './m-sheet.vue';
import MFab from './m-fab.vue';
import MPager from './m-pager.vue';
import MToolbar from './m-toolbar.vue';

const components = {
    MPage,
    MTable,
    MSearch,
    MSheet,
    MFab,
    MPager,
    MToolbar,
};

export default {
    install(Vue) {
        Object.keys(components).forEach((name) => {
            Vue.component(name, components[name]);
        });
    },
};

export { MPage, MTable, MSearch, MSheet, MFab, MPager, MToolbar };
